import { jsx as _jsx } from "react/jsx-runtime";
import { Button, ButtonState, Popover, PopoverType, usePopoverHandlers } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { EventEnum } from '@as-react/common-types';
import { EventUtil } from '@as-react/common-utils';
import { Box, Stack, TextAlpha, useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { useFeatureToggle } from '../../hooks/useFeatureToggle';
import { useOAuth } from '../../hooks/useOAuth';
import sessionActions from '../../redux/session/actions/SessionActions.creators';
export const SecurityLevelsPopup = () => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const isMobile = useMediaQueryMatchesOnMobile();
    const { root } = useAemConfig();
    const dispatch = useDispatch();
    const [buttonState, setButtonState] = useState(ButtonState.INTERACTIVE);
    const { authUrl, logout } = useOAuth();
    const isNewAuth = useFeatureToggle('use_new_auth_flow');
    const handlePopoverLogout = () => {
        setButtonState(ButtonState.LOADING);
        isNewAuth ? logout() : dispatch(sessionActions.createLogoutAction());
        window.location.href = isNewAuth ? authUrl : `${root}account.html`;
    };
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers();
    const handleShowSecurityLevelsPopup = () => handlePopoverOpen(null, null, true);
    useEffect(() => {
        EventUtil.listen(EventEnum.USER_SECURITY_LEVEL_TOO_LOW, handleShowSecurityLevelsPopup);
        return () => EventUtil.remove(EventEnum.USER_SECURITY_LEVEL_TOO_LOW, handleShowSecurityLevelsPopup);
    }, []);
    return (_jsx(Popover, { anchorEl: anchorEl, type: PopoverType.MODAL, onClose: handlePopoverClose, noFooterShadow: true, footerElement: _jsx(Box, { paddingInline: { md: '4' }, paddingBlockEnd: { md: '4' }, children: _jsx(Stack, { justify: "end", children: _jsx(Button, { fill: isMobile, text: t('account.security.levels.popup.button'), onClick: handlePopoverLogout, state: buttonState }) }) }), dataQA: "security_level_popup", children: _jsx(Box, { paddingBlockEnd: { base: '2', md: '4' }, paddingInline: { base: '4', md: '8' }, children: _jsx(TextAlpha, { children: t('account.security.levels.popup.info') }) }) }));
};
